/** Formats PointLight2D properties for the details panel: the Light2D surface, its height and its texture scale. */
import { formatLight2DProperties } from '../lights/shared/propertyFormatter';
export function formatPointLight2DProperties(props) {
    return formatLight2DProperties(props, [
        { label: 'Height', value: `${props.height.toFixed(0)} px` },
        { label: 'Texture Scale', value: props.texture_scale.toFixed(2) },
    ]);
}
//# sourceMappingURL=propertyFormatter.js.map